function p(e, a, l) {
  switch (l.length) {
    case 0:
      return e.call(a);
    case 1:
      return e.call(a, l[0]);
    case 2:
      return e.call(a, l[0], l[1]);
    case 3:
      return e.call(a, l[0], l[1], l[2]);
  }
  return e.apply(a, l);
}
var c = p;
export {
  c as default
};
//# sourceMappingURL=_apply.js.map
